import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'eiq-validation-text',
  templateUrl: 'validation-text.component.html',
  styleUrls: ['validation-text.component.scss']
})
export class ValidationTextComponent {
  formCtrl = input<AbstractControl<any>>();
}
